module.exports = __webpack_public_path__ + "img/q-app-hd.1f023e44.png";